// 黑料色 —— 首页静态展示数据（仅供视觉展示，无真实接口）

export interface CoverItem {
  id: string;
  title: string;
  summary: string;
  tags: string[];
  heat: number;
  save: number;
  img: string;
  cat: string;
}

export interface PaletteItem {
  id: string;
  name: string;
  scene: string;
  colors: string[];
  tags: string[];
  tone: string;
  heat: number;
  img: string;
}

export interface LayoutItem {
  id: string;
  title: string;
  summary: string;
  grid: string;
  tags: string[];
  heat: number;
  img: string;
}

export const heroStats = [
  { label: '封面 / 海报档案', value: '3,200+' },
  { label: '配色方案', value: '1,860 套' },
  { label: '调色参数速查', value: '940 组' },
  { label: '设计师累计收藏', value: '127k' },
];

export const heatRank = [
  { rank: 1, name: '黑底火焰风封面', heat: 98, trend: 'up', save: '8.4k 收藏' },
  { rank: 2, name: '暗调海报撞色参考', heat: 91, trend: 'up', save: '6.1k 收藏' },
  { rank: 3, name: '杂志大字号版式', heat: 84, trend: 'up', save: '4.7k 收藏' },
];

export const coverList: CoverItem[] = [
  {
    id: 'cover-1',
    cat: '封面',
    title: '黑底留白式封面：一句话定调',
    summary: '大面积黑底压住版面，只留一行标题与角标，把「克制」做成本页唯一的情绪。适合专辑、节目与活动主视觉。',
    tags: ['黑底', '留白', '大字标题'],
    heat: 98,
    save: 8421,
    img: 'https://readdy.ai/api/search-image?query=dark%20editorial%20album%20cover%20design%20with%20near%20black%20background%20and%20one%20oversized%20white%20bold%20headline%20left%20aligned%20with%20ample%20negative%20space%20and%20a%20small%20burnt%20orange%20corner%20badge%20subtle%20film%20grain%20brutalist%20modern%20print%20layout&width=900&height=560&seq=cover-ink-1&orientation=landscape',
  },
  {
    id: 'cover-2',
    cat: '封面',
    title: '撞色双色块封面：直给也耐看',
    summary: '两块高饱和色硬切拼贴，标题压在交界线附近，远处看是一张牌，近处看是两套调色在打架。',
    tags: ['撞色', '拼贴', '色块'],
    heat: 89,
    save: 6103,
    img: 'https://readdy.ai/api/search-image?query=editorial%20poster%20cover%20with%20hard%20geometric%20split%20two%20color%20blocks%20of%20warm%20amber%20and%20deep%20crimson%20on%20off%20black%20paper%20bold%20typography%20headline%20placed%20on%20the%20seam%20flat%20graphic%20print%20style%20grain%20texture&width=900&height=560&seq=cover-ink-2&orientation=landscape',
  },
  {
    id: 'cover-3',
    cat: '海报',
    title: '海报噪点人物风：情绪先行的调色',
    summary: '把人物压进噪点与暗部里，肤色往暖调拉，四周沉成炭黑，一张海报的情绪从调色就开始铺垫。',
    tags: ['噪点', '人物', '暗调'],
    heat: 84,
    save: 4702,
    img: 'https://readdy.ai/api/search-image?query=editorial%20poster%20with%20a%20film%20grain%20dark%20portrait%20sinking%20into%20shadow%20warm%20skin%20tones%20surrounded%20by%20charcoal%20black%20with%20a%20single%20line%20of%20headline%20text%20moody%20cinematic%20color%20grading%20print%20design&width=900&height=560&seq=cover-ink-3&orientation=landscape',
  },
  {
    id: 'cover-4',
    cat: '版式',
    title: '杂志双栏版式：把排版当节奏',
    summary: '标题、导语、正文用字号与栏宽区分节奏，穿插一个跨栏大图，版式本身就是阅读的节拍器。',
    tags: ['双栏', '杂志', '图文'],
    heat: 79,
    save: 3905,
    img: 'https://readdy.ai/api/search-image?query=magazine%20editorial%20spread%20layout%20with%20two%20text%20columns%20serif%20headline%20drop%20cap%20and%20one%20full%20bleed%20dark%20photograph%20with%20page%20number%20and%20masthead%20classic%20print%20typography%20black%20ink%20on%20cream%20paper&width=900&height=560&seq=cover-ink-4&orientation=landscape',
  },
];

export const paletteList: PaletteItem[] = [
  {
    id: 'pal-1',
    name: '炭暖橙',
    scene: '产品主视觉',
    colors: ['#171310', '#8A4A1F', '#D97B29', '#F2B14B', '#F7EFE6'],
    tags: ['暗调', '高对比'],
    tone: '暖调 2000K',
    heat: 98,
    img: 'https://readdy.ai/api/search-image?query=color%20palette%20swatch%20card%20on%20matte%20black%20paper%20showing%20five%20horizontal%20bands%20of%20charcoal%20burnt%20copper%20warm%20amber%20and%20cream%20with%20soft%20grain%20abstract%20design%20inspiration%20moodboard&width=800&height=800&seq=palette-charcoal-1&orientation=squarish',
  },
  {
    id: 'pal-2',
    name: '焦糖暗红',
    scene: '餐饮 / 品牌',
    colors: ['#241512', '#7A2E23', '#C04B32', '#E88A4A', '#F3D9BE'],
    tags: ['复古', '食欲感'],
    tone: '暗红 30%',
    heat: 91,
    img: 'https://readdy.ai/api/search-image?query=abstract%20color%20palette%20moodboard%20of%20deep%20brown%20dark%20crimson%20burnt%20orange%20and%20warm%20beige%20horizontal%20color%20stripes%20on%20dark%20textured%20background%20flat%20graphic%20print%20design&width=800&height=800&seq=palette-caramel-2&orientation=squarish',
  },
  {
    id: 'pal-3',
    name: '烟灰茶绿',
    scene: '杂志封面',
    colors: ['#161A18', '#3C4A42', '#6E8577', '#B4A482', '#EFE6D6'],
    tags: ['低饱和', '高级灰'],
    tone: '冷调偏灰',
    heat: 86,
    img: 'https://readdy.ai/api/search-image?query=muted%20color%20palette%20swatches%20of%20dark%20charcoal%20sage%20green%20dusty%20olive%20taupe%20and%20ivory%20arranged%20as%20horizontal%20bars%20on%20a%20soft%20dark%20canvas%20minimal%20editorial%20moodboard&width=800&height=800&seq=palette-smoke-3&orientation=squarish',
  },
  {
    id: 'pal-4',
    name: '铁锈水洗',
    scene: '活动海报',
    colors: ['#1C1713', '#5A3A26', '#A45F2C', '#CF8A3F', '#E8C79A'],
    tags: ['做旧', '质感'],
    tone: '暖调 2400K',
    heat: 82,
    img: 'https://readdy.ai/api/search-image?query=rusty%20washed%20color%20palette%20on%20matte%20dark%20paper%20with%20five%20swatch%20bars%20of%20espresso%20leather%20rust%20mustard%20and%20sand%20with%20subtle%20aged%20grain%20vintage%20poster%20design%20inspiration&width=800&height=800&seq=palette-rust-4&orientation=squarish',
  },
  {
    id: 'pal-5',
    name: '霓虹墨绿',
    scene: '演出主视觉',
    colors: ['#0D120F', '#123832', '#1F7A68', '#4CC9A3', '#EAF6EE'],
    tags: ['霓虹', '舞台'],
    tone: '偏冷',
    heat: 90,
    img: 'https://readdy.ai/api/search-image?query=neon%20dark%20green%20teal%20color%20palette%20swatch%20bands%20glowing%20emerald%20and%20mint%20against%20near%20black%20green%20background%20concert%20visual%20style%20electric%20abstract%20moodboard&width=800&height=800&seq=palette-neon-5&orientation=squarish',
  },
  {
    id: 'pal-6',
    name: '烟熏酒红',
    scene: '酒饮 / 潮牌',
    colors: ['#180E10', '#4A1822', '#8C2B3C', '#C76B6B', '#EFE0DB'],
    tags: ['酒红', '夜场'],
    tone: '酒红 25%',
    heat: 77,
    img: 'https://readdy.ai/api/search-image?query=smoky%20burgundy%20wine%20red%20color%20palette%20swatches%20deep%20maroon%20raspberry%20and%20pale%20pink%20on%20dark%20velvet%20black%20background%20premium%20streetwear%20label%20moodboard%20grain&width=800&height=800&seq=palette-wine-6&orientation=squarish',
  },
  {
    id: 'pal-7',
    name: '荒漠岩土',
    scene: '文旅 / 户外',
    colors: ['#211A14', '#5A4430', '#97714A', '#C89B68', '#EBD6B7'],
    tags: ['大地色', '自然'],
    tone: '暖调 2200K',
    heat: 88,
    img: 'https://readdy.ai/api/search-image?query=desert%20terracotta%20sandstone%20color%20palette%20bands%20of%20dark%20chocolate%20clay%20amber%20and%20sahara%20sand%20on%20warm%20dark%20stone%20background%20outdoor%20brand%20editorial%20moodboard&width=800&height=800&seq=palette-desert-7&orientation=squarish',
  },
  {
    id: 'pal-8',
    name: '午夜靛青',
    scene: '音乐人专辑',
    colors: ['#0E1218', '#22303F', '#3E6076', '#7BA6B4', '#DCE7E9'],
    tags: ['冷调', '静谧'],
    tone: '偏冷',
    heat: 74,
    img: 'https://readdy.ai/api/search-image?query=deep%20midnight%20teal%20steel%20blue%20color%20palette%20swatch%20bars%20dark%20navy%20slate%20and%20mist%20on%20near%20black%20background%20quiet%20music%20album%20visual%20moodboard%20minimal&width=800&height=800&seq=palette-midnight-8&orientation=squarish',
  },
];

export const layoutList: LayoutItem[] = [
  {
    id: 'lay-1',
    title: '跨栏大图 × 压角题',
    summary: '一页只做一件大事：大图占满两栏，标题压在图角，导语放对面留白。',
    grid: '2 栏结构',
    tags: ['跨栏图', '压角题'],
    heat: 93,
    img: 'https://readdy.ai/api/search-image?query=vertical%20magazine%20spread%20layout%20mockup%20with%20a%20full%20bleed%20dark%20photograph%20on%20the%20left%20half%20and%20a%20large%20serif%20headline%20pushed%20to%20the%20bottom%20corner%20with%20white%20space%20on%20the%20right%20print%20editorial%20grid%20design&width=760&height=960&seq=layout-mag-1&orientation=portrait',
  },
  {
    id: 'lay-2',
    title: '纵列清单式导览',
    summary: '竖排的信息层级：编号、标题、一行摘要排成纵列，扫读时自带节奏。',
    grid: '纵列清单',
    tags: ['编号', '清单'],
    heat: 81,
    img: 'https://readdy.ai/api/search-image?query=editorial%20layout%20poster%20with%20vertical%20numbered%20list%20of%20headlines%20and%20short%20captions%20in%20clean%20columns%20on%20dark%20paper%20with%20thin%20rule%20lines%20and%20warm%20amber%20page%20numbers%20modern%20print%20grid%20inspiration&width=760&height=960&seq=layout-list-2&orientation=portrait',
  },
  {
    id: 'lay-3',
    title: '反白色块分割版面',
    summary: '用反白色块把同一张图切成上下两种情绪，标题落在明暗交界，层次立刻出来。',
    grid: '色块分割',
    tags: ['反白', '明暗'],
    heat: 88,
    img: 'https://readdy.ai/api/search-image?query=editorial%20layout%20with%20inverted%20white%20geometric%20block%20cutting%20a%20dark%20photograph%20into%20two%20halves%20with%20a%20bold%20headline%20centered%20on%20the%20contrast%20line%20minimal%20print%20grid%20design%20black%20and%20white&width=760&height=960&seq=layout-block-3&orientation=portrait',
  },
  {
    id: 'lay-4',
    title: '出血框杂志页',
    summary: '文字框局部出血到版心外，制造「装不下的信息」，是杂志感最快的一招。',
    grid: '出血版式',
    tags: ['出血', '杂志感'],
    heat: 76,
    img: 'https://readdy.ai/api/search-image?query=bleed%20grid%20magazine%20page%20design%20where%20a%20serif%20headline%20box%20overflows%20past%20the%20inner%20margin%20over%20a%20dark%20ink%20photograph%20with%20caption%20and%20folio%20numbers%20editorial%20print%20layout&width=760&height=960&seq=layout-bleed-4&orientation=portrait',
  },
  {
    id: 'lay-5',
    title: '栅格切图拼贴',
    summary: '把一张海报按 3×3 栅格打散再错位重拼，图块之间留一道黑缝，科技与印刷感并存。',
    grid: '3×3 栅格',
    tags: ['拼贴', '错位'],
    heat: 84,
    img: 'https://readdy.ai/api/search-image?query=deconstructed%20poster%20grid%20collage%20splitting%20one%20dark%20graphic%20into%20offset%20tiles%20with%20thin%20black%20gaps%20warm%20orange%20accents%20modern%20art%20print%20editorial%20layout%20grain&width=760&height=960&seq=layout-grid-5&orientation=portrait',
  },
  {
    id: 'lay-6',
    title: '超大字标题居中版',
    summary: '一个词撑满整页宽度，上下只留编号与页码，戏剧张力全押在字重上。',
    grid: '单栏大字',
    tags: ['大字', '居中'],
    heat: 79,
    img: 'https://readdy.ai/api/search-image?query=editorial%20poster%20with%20one%20enormous%20centered%20serif%20word%20filling%20the%20full%20width%20on%20black%20background%20with%20small%20folio%20numbers%20top%20and%20bottom%20bold%20typographic%20print%20design%20minimal&width=760&height=960&seq=layout-bigtype-6&orientation=portrait',
  },
];

export const toneParams = [
  { key: '色温', value: '2100–2400K', note: '偏暖易出怀旧与食欲感' },
  { key: '高光', value: '+12', note: '保护高光，别让白爆成死白' },
  { key: '阴影', value: '-28', note: '压暗部，沉出黑底质感' },
  { key: '对比', value: '+16', note: '拉开明暗，让层次更利落' },
  { key: '颗粒', value: '+8', note: '胶片噪点，统一质感' },
  { key: '锐度', value: '+6', note: '文字边缘要硬，别发虚' },
];

export const archiveCat = [
  { name: '封面黑底风', count: 486, icon: 'ri-layout-3-fill' },
  { name: '海报撞色派', count: 392, icon: 'ri-artboard-fill' },
  { name: '版式大字流', count: 305, icon: 'ri-format-clear' },
  { name: '暗调人像档', count: 268, icon: 'ri-user-fill' },
  { name: '复古印刷册', count: 241, icon: 'ri-printer-fill' },
  { name: '胶片噪点集', count: 193, icon: 'ri-film-fill' },
];